// Cliente del servidor del vivo (vivo-pro en la EC2 de ROP, detrás de https://360.lisual.com/vivo).
// El servidor valida la sesión del usuario contra webback, busca el UID de la cámara en Firestore y aplica los
// topes (2 min por transmisión, minutos por día, cámaras a la vez). Acá sólo se pide la sesión y se espera el video.

export const VIVO_URL = (process.env.REACT_APP_VIVO_URL || 'https://360.lisual.com/vivo').replace(/\/$/, '');
const ORIGEN = VIVO_URL.replace(/\/vivo$/, '');

export class ErrorVivo extends Error {
  constructor(codigo, mensaje, datos = {}) {
    super(mensaje);
    this.codigo = codigo;
    this.datos = datos;
  }
}

const MENSAJE_GENERICO = 'No pudimos abrir el vivo en este momento.';

export const pedirSesion = async ({ identifier, calidad }) => {
  let token = null;
  try { token = localStorage.getItem('authLisualToken'); } catch (e) { /* sin acceso al storage */ }
  let r;
  try {
    r = await fetch(`${VIVO_URL}/api/sesion`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ identifier, calidad }),
    });
  } catch (e) {
    throw new ErrorVivo('red', 'No pudimos conectarnos con el vivo. Revisá tu conexión a internet.');
  }
  const datos = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new ErrorVivo(typeof datos.codigo === 'string' ? datos.codigo : 'interno',
      typeof datos.mensaje === 'string' && datos.mensaje ? datos.mensaje : MENSAJE_GENERICO, datos);
  }
  if (typeof datos.hls !== 'string' || !datos.hls.startsWith('/vivo/hls/')) throw new ErrorVivo('interno', MENSAJE_GENERICO);
  return { ...datos, hls: ORIGEN + datos.hls };
};

// Pedir la playlist es lo que mantiene despierta a la cámara mientras arranca. 404 = todavía despertando
// (o sin señal, según X-Vivo-Estado); 410 = terminó la sesión (corte de los 2 min o tope del día).
export const consultarPlaylist = async (url) => {
  try {
    const r = await fetch(url, { cache: 'no-store' });
    if (r.ok) return { listo: /\.(ts|m4s)\b/.test(await r.text()), status: r.status };
    const datos = await r.json().catch(() => ({}));
    return { listo: false, status: r.status, estado: r.headers.get('X-Vivo-Estado') || datos.codigo, mensaje: datos.mensaje };
  } catch (e) {
    return { listo: false, status: 0, estado: 'red' };
  }
};

// La señal alta de las Reolink es HEVC 4K: sólo se pide si el navegador la puede decodificar (hls.js en fMP4, o
// HLS nativo en iPhone/Safari). Si no, se pide la chica (h264), que anda en todos lados.
export const soportaHevc = () => {
  try {
    if (window.MediaSource?.isTypeSupported?.('video/mp4;codecs="hvc1.2.4.L153.B0"')) return true;
    const v = document.createElement('video');
    return !!(v.canPlayType('application/vnd.apple.mpegurl') && v.canPlayType('video/mp4;codecs="hvc1"'));
  } catch (e) {
    return false;
  }
};
